import React, { lazy, ReactElement, Suspense } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import * as LoadingStates from '../constants/LoadingStates'
import platePage from '../data/plates.json'

interface IProps {
  loadingState: string
}

const PlateLoader: React.FC<IProps> = ({ loadingState }) => {
  const { pathname } = useLocation()
  const { plate_id } = useParams()
  let PlateComponent = lazy(() => import('./NotFound'))

  const getPlate = (): ReactElement | null => {
    const plateEnv =
      platePage[process.env.REACT_APP_ENVIRONMENT as keyof typeof platePage]
    const plate = plateEnv[plate_id as keyof typeof plateEnv]
    const path = pathname.split('/')[1]

    if (plate !== undefined) {
      PlateComponent = lazy(() => import(`../components/${path}/${plate}`))
    }

    return <PlateComponent />
  }

  const getLoadedState = (): ReactElement => {
    switch (loadingState) {
      case LoadingStates.LOADING:
        return <div>Loading plates</div>
      case LoadingStates.AUTHENTICATED:
        return (
          <Suspense fallback={<div>Loading...</div>}>{getPlate()}</Suspense>
        )
      case LoadingStates.DENIED:
        return <div>Not Logged In.</div>
      case LoadingStates.NOTIFRAME:
        return <div>This plate can only be viewed on the Librios platform.</div>
      default:
        return <div>There was an error</div>
    }
  }

  return <div>{getLoadedState()}</div>
}

export default PlateLoader
